export default {
    STATE_CUSTOM_PRICE : 'custom_price',
    STATE_CUSTOM_DISCOUNT_PRICE : 'custom_discount_price',
    CUSTOM_PRICE_DISCOUNT_PERCENT: '%',
}



// WEBPACK FOOTER //
// ./src/view/constant/checkout/cart/ItemConstant.js